import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { SubscriptionItem } from 'src/features/subscriptionItems/utils/types';
import { SubscriptionItemFormSchemaValues } from 'src/features/subscriptionItems/utils/formSchema';

const RESOURCE = '/subscriptions/subscription/:subscriptionId/subscription-item/';

type MutationFnType = typeof mutationFn;

interface DTO extends SubscriptionItemFormSchemaValues {
    subscriptionId: string;
}
const mutationFn = ({ subscriptionId, ...data }: DTO): Promise<SubscriptionItem> => {
    return axios.post(formatResourcePath(RESOURCE, { subscriptionId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSubscriptionItem };
